export default "__VITE_ASSET__9aCKsvgZ__"